import getImageById from '@/components/ImageSelector/getImageById';

const mutations = {
    setFieldId(state, value) {
        state.fieldId = value;
    },

    setLevel(state,value) {
        state.level = value;
    },

    setOrder(state, value) {
        state.order = value;
    },

    setPublished(state, value) {
        state.published = value;
    },

    setType(state, value) {
        state.type = value;
    },

    setTypes(state, value) {
        state.types = value;
    },

    setName(state, value) {
        state.name = value;
    },

    setCard(state, value) {
        state.card = value;
    },

    setCards(state, value) {
        state.cards = value;
    },

    setCardData(state, value) {
        state.cardData = value;
    },

    setSection(state, value) {
        state.section = value;
    },

    setSectionData(state, value) {
        state.sectionData = value;
    },

    setPage(state, value) {
        state.page = value;
    },

    setPageData(state, value) {
        state.pageData = value;
    },

    setStep(state, value) {
        state.step = value;
    },

    setStepData(state, value) {
        state.stepData = value;
    },

    setHydrated(state, value) {
        state.hydrated = value;
    },

    /**
     * I don't think we need this
     * Controlled by modal component.
     */
    toggleHelpModal(state, value) {
        state.helpModal = value;
    },

    toggleDeleteModal(state, value) {
        state.deleteModal = value;
    },

    // set population
    setPopulation(state, value) {
        state.population = value;
    },

    setPopulations(state, value) {
        state.populations = value;
    },

    setSubmission(state, value) {
        state.submission = value;
    },

    setEntry(state, value) {
        state.entry = value;
    },



    /**
     * Options
     */
    setStaticText(state, value) {
        state.options.staticText = value;
    },

    setAudio(state, value) {
        state.options.audio = value;
    },

    setFieldsInGroup(state, value) {
        state.options.fieldsInGroup = value;
    },

    setGroupInline(state, value) {
        state.options.groupInline = value;
    },

    setGroupNumbered(state, value) {
        state.options.groupNumbered = value;
    },

    setOptionsGroup(state, value) {
        state.options.group = value;
    },

    setLoadStock(state, value) {
        state.options.loadStock = value;
    },

    setUploadType(state, value) {
        state.options.uploadType = value;
    },

    setUploaderInstructionText(state, value) {
        state.options.uploaderInstructionText = value;
    },

    setHelpTitle(state, value) {
        state.options.helpTitle = value;
    },

    setHelpText(state, value) {
        state.options.helpText = value;
    },

    setCustomColorAccessLevel(state, value) {
        state.options.customColorAccessLevel = value;
    },

    setCustomColorUpsell(state, value) {
        state.options.customColorUpsell = value;
    },

    setCustomFontAccessLevel(state, value) {
        state.options.customFontAccessLevel = value;
    },

    setCustomFontUpsell(state, value) {
        state.options.customFontUpsell = value;
    },

    setPreviewHeroHeadline(state, value) {
        state.options.preview.heroHeadline = value;
    },

    setPreviewHeroSubhead(state, value) {
        state.options.preview.heroSubhead = value;
    },

    setPreviewHeroButtonText(state, value) {
        state.options.preview.heroButtonText = value;
    },

    setPreviewBanner1(state, value) {
        state.options.preview.banner1 = value;
    },

    setPreviewBanner2(state, value) {
        state.options.preview.banner2 = value;
    },

    setPreviewBanner3(state, value) {
        state.options.preview.banner3 = value;
    },

    setPreviewBodyHeadline(state, value) {
        state.options.preview.bodyHeadline = value;
    },

    setPreviewBodyCopy(state, value) {
        state.options.preview.bodyCopy = value;
    },

    setPreviewBodyButtonText(state, value) {
        state.options.preview.bodyButtonText = value;
    },

    setPreviewHeroImage(state, value) {
        state.options.preview.heroImage = value;
        getImageById(value)
            .then(image => {
                state.options.preview.heroImageSrc = this._vm.$storageURL + image.directory + '/' + image.filename + '.' + image.extension;
            }).catch(() => {
                state.options.preview.heroImageSrc = '';
            });
    },

    setPreviewHeadshot(state, value) {
        state.options.preview.headshot = value;
        getImageById(value)
            .then(image => {
                state.options.preview.headshotSrc = this._vm.$storageURL + image.directory + '/' + image.filename + '.' + image.extension;
            }).catch(() => {
                state.options.preview.headshotSrc = '';
            });
    },

    setTrainingVideoThumbnail(state, value) {
        state.options.training.video.thumbnail.id = value;

        getImageById(value)
            .then(image => {
                state.options.training.video.thumbnail.src = this._vm.$storageURL + image.directory + '/' + image.filename + '.' + image.extension;
            })
            .catch(() => {
                state.options.training.video.thumbnail.src = '';
            });
    },

    setTrainingVideoId(state, value) {
        state.options.training.video.id = value;
    },

    setTrainingDownloadId(state, value) {
        state.options.training.download.id = value;
    },

    setTrainingDownloadURL(state, value) {
        state.options.training.download.url = value;
    },

    setTrainingDescription(state, value) {
        state.options.training.description = value;
    },

    setShowUploadButton(state, value) {
        state.options.showUploadButton = value;
    },

    setShowSelectButton(state, value) {
        state.options.showSelectButton = value;
    },

    setHeroSelectorLabel(state, value) {
        state.options.heroSelector.label = value;
    },

    setHeroSelectorChoiceOne(state, value) {
        state.options.heroSelector.choiceOne = value;
    },

    setHeroSelectorChoiceTwo(state, value) {
        state.options.heroSelector.choiceTwo = value;
    },

    setTemplateSelectorLabel(state, value) {
        state.options.templateSelector.label = value;
    },

    setTemplateSelectorColorOne(state, value) {
        state.options.templateSelector.colorOne = value;
    },

    setTemplateSelectorColorTwo(state, value) {
        state.options.templateSelector.colorTwo = value;
    },

    setTemplateSelectorColorThree(state, value) {
        state.options.templateSelector.colorThree = value;
    },

    setUpsell(state, value) {
        state.options.upsell = value;
    },

    setStockMedia(state, value) {
        state.stockMedia = value;
    },

    setUserMedia(state, value) {
        state.userMedia = value;
    },
};

export default mutations;
